import React from 'react';
import { Form, FormikConfig } from 'formik';

import { Button, Input, InputField } from '../../components';
import { FormContextProvider } from '../../context';
import { AuthHeader } from '../';
import { validationSchema } from './sign-in-form.form';

export type SignInFormValues = {
  username: string;
  password: string;
};

export type SignInFormProps = {
  isPending?: boolean;
  error?: string;
  onChange?: () => void;
  onSubmit: FormikConfig<SignInFormValues>['onSubmit'];
  secondaryActionElement?: React.ReactNode;
};

export const SignInForm = ({
  isPending,
  onChange,
  onSubmit,
  secondaryActionElement,
}: SignInFormProps) => (
  <FormContextProvider<SignInFormValues>
    initialValues={{ username: '', password: '' }}
    validationSchema={validationSchema}
    onChange={onChange}
    onSubmit={onSubmit}
  >
    <Form>
      <AuthHeader heading="Enter your login details" />
      <div className="space-y-4 mb-8">
        <InputField name="username" showRequiredIndicator={false}>
          {(field) => <Input type="email" autoComplete="username" {...field} />}
        </InputField>
        <InputField name="password" showRequiredIndicator={false}>
          {(field) => (
            <Input type="password" autoComplete="current-password" {...field} />
          )}
        </InputField>
      </div>
      <div className="flex items-center">
        {secondaryActionElement}
        <div className="flex-1" />
        <Button type="submit" isPending={isPending}>
          Login
        </Button>
      </div>
    </Form>
  </FormContextProvider>
);
